import React from 'react';
import { hydrateRoot }  from 'react-dom/client';
import { ApolloProvider } from '@apollo/client';
import App from './App';
import {BrowserRouter} from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { loadableReady } from '@loadable/component';
import { createClient }  from './graphql/client'

// Wyłączenie logów w trybie produkcyjnym
const isDevelopment = process.env.NODE_ENV !== 'production';
if (!isDevelopment) {
    console.log = () => {};
    console.warn = () => {};
    // console.error = () => {}; // Opcjonalnie zostaw console.error dla krytycznych błędów
}


// Dodajemy obsługę hot reload
if (module.hot ) {
  console.log('HMR aktywny - aplikacja będzie automatycznie odświeżać się po zmianach kodu');

  // Wymuszamy pełne przeładowanie strony po aktualizacji
  module.hot.accept('./App', () => {
    console.log('App module updated - reloading');
    window.location.reload();
  });

  // Nasłuchujemy na wszystkie aktualizacje
  module.hot.accept();

  // Obsługa błędów
  module.hot.addStatusHandler(status => {
    if (status === 'abort' || status === 'fail') {
      console.log('HMR aktualizacja nieudana, przeładowuję stronę...');
      window.location.reload();
    }
  });

  console.log(`💻 Client initialized at ${new Date().toLocaleTimeString()} - HMR READY`);
}

const csrOnly = window.__CSR_ONLY__ === true;
// Initialize Apollo Client with the cached data from the server
const apolloClient = createClient(false, window.__APOLLO_STATE__);
console.log('CLIENT JS LOADED', new Date());
const helmetContext = {};
// Główna aplikacja
const AppTree = (
    <HelmetProvider context={helmetContext}>
        <ApolloProvider client={apolloClient}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </ApolloProvider>
    </HelmetProvider>
);

// Element kontenera
const container = document.getElementById('root');
if (!container) {
    throw new Error('Nie znaleziono elementu #root w HTML!');
}

// Obsługa hydratacji z lepszym zarządzaniem błędami
if (csrOnly) {
    // Tryb tylko po stronie klienta (CSR) bez próby hydratacji
    console.log('Using client-side rendering mode (CSR)');
    const { createRoot } = require('react-dom/client');
    const root = createRoot(container);
    root.render(AppTree);
} else {
    // Standardowa ścieżka z hydratacją zawartości wyrenderowanej na serwerze
    console.log('Using hydration for server-rendered content');
    
    // Ustawiamy flagi dla lepszego śledzenia
    window.__HYDRATION_ATTEMPTED = true;

    // Czekamy na załadowanie zasobów przed próbą hydratacji
    loadableReady(() => {
        try {
            // Używamy hydrateRoot z obsługą błędów
            const root = hydrateRoot(container, AppTree, {
                onRecoverableError: (error, errorInfo) => {
                    console.warn('Recovered from hydration error:', error);
                    console.log('Error info:', errorInfo);
                }
            });
            
            console.log('Hydration completed successfully');
            window.__HYDRATION_SUCCEEDED = true;
        } catch (error) {
            console.error('Hydration failed, falling back to client-side rendering:', error);
            
            // Oznaczamy, że hydratacja nie powiodła się
            window.__HYDRATION_SUCCEEDED = false;
            
            // Usuwamy zawartość kontenera, aby uniknąć problemów z dublowaniem treści
            while (container.firstChild) {
                container.removeChild(container.firstChild);
            }
            
            // Przełączamy się na pełne renderowanie po stronie klienta
            const { createRoot } = require('react-dom/client');
            const root = createRoot(container);
            root.render(AppTree);
        }
    });
}